export default __webpack_public_path__ + "static/media/promo-vip-banner-cn.fb3209be.webp";